import React, {Component} from "react";
import {Switch, Route} from "react-router-dom";

import ApplicationHome from "./applicationDashboard";
import ChannelDashboard from "./channelDashboard";
import StoreDashboard from "./store";
import Product from "./productPage";
import PaymentResponse from "./payments";
import Resources from './resources';
import Unit from './unit'

let Application = class Application extends Component {
  render() {
    return <Switch>
      <Route path="/application/paymentResponse/:txnid" component={ PaymentResponse }/>
      <Route path="/application/channel/:channelId/:sessionId" component={ ChannelDashboard }/>
      <Route path="/application/explore/:channelId/:sessionId" component={ Product }/>
      <Route path="/application/library" component={StoreDashboard}/>
      <Route path="/application/dashboard" component={ApplicationHome}/>
      <Route path="/application/resources/:resourceId" component={ Resources }/>
      <Route path="/application/resource/:groupId/:resourceId" component={ Unit }/>
      <Route path="/application/" component={ApplicationHome}/>
    </Switch>
  }
}

export default Application;